import { Observable } from 'rxjs';

import {
  DprConsumable,
  DprDetails,
  DprHse,
  DprPersonnel,
  DprProgress,
  DprProgressWithoutTarget,
  DprStatusTracker,
  DprTableOfColumns,
  DprWeather,
} from '@shared/models/dpr';
import {
  DprActivitiesGridSync,
  DprActivitiesGridSyncResult,
  DprHseGridSync,
  DprPersonnelGridSync,
  DprWeatherGridSync,
  DprConsumableGridSync,
  DprSummaryGridSync,
  DprSummaryGridSyncResult,
  DprProgressGridSync,
  DprAppendixGridSync,
  DprAppendixGridSyncResult,
  DprForecastActivitiesGridSyncResult,
  DprForecastActivitiesGridSync,
  DprHiddenGridSync,
  DprStatusTrackerGridSync,
  DprProgressWithoutTargetGridSync,
  DprHiddenGridSyncResult,
  DprFreeTextFieldSync,
  DprFreeTextFieldSyncResult,
  DprTableOfColumnGridSync,
} from '@dpr-details/models/sync';

import {
  CopyPreviousDprForecastActivitiesOptions,
  CopyPreviousDprForecastActivitiesResult,
} from '@dpr-details/models';

export abstract class DprDetailsBasePersistenceService {
  abstract getDprDetails(dprDetailId: number | string): Observable<DprDetails>;

  abstract syncDprActivities(
    data: DprActivitiesGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprActivitiesGridSyncResult>;

  abstract syncDprStatusTracker(
    data: DprStatusTrackerGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprStatusTracker>;

  abstract syncDprWeather(
    data: DprWeatherGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprWeather>;

  abstract syncDprHse(
    data: DprHseGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprHse>;

  abstract syncDprPersonnel(
    data: DprPersonnelGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprPersonnel>;

  abstract syncDprConsumable(
    data: DprConsumableGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprConsumable>;

  abstract syncDprSummary(
    data: DprSummaryGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprSummaryGridSyncResult>;

  abstract syncDprForecastActivities(
    data: DprForecastActivitiesGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprForecastActivitiesGridSyncResult>;

  abstract copyDprForecastActivitiesFromPreviousDpr(
    options: CopyPreviousDprForecastActivitiesOptions
  ): Observable<CopyPreviousDprForecastActivitiesResult>;

  abstract syncDprFreeTextField(
    data: DprFreeTextFieldSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprFreeTextFieldSyncResult>;

  abstract syncDprSummaryExternalComment(
    data: DprSummaryGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprSummaryGridSyncResult>;

  abstract syncDprProgress(
    data: DprProgressGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprProgress>;

  abstract syncDprProgressWithoutTarget(
    data: DprProgressWithoutTargetGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprProgressWithoutTarget>;

  abstract syncDprTableOfColumns(
    data: DprTableOfColumnGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprTableOfColumns>;

  abstract syncDprAppendix(
    data: DprAppendixGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprAppendixGridSyncResult>;

  abstract syncDprHidden(
    data: DprHiddenGridSync,
    isAutoSyncFromAdminChange: boolean
  ): Observable<DprHiddenGridSyncResult>;

  abstract getPreviousDprDetailsId(dprDate: Date): Observable<number | string>;

  abstract getNextDprDetailsId(dprDate: Date): Observable<number | string>;

  abstract isFirstDpr(dprDate: Date): Observable<boolean>;
}
